const regionDisplayOptions = [
  [
  { value: 'state', label: 'States' },
  { value: 'fips', label: 'States + Counties (FIPS)' }
 
],
[
  { value: 'fips', label: 'States + Counties (FIPS)' }]
 
]

export default regionDisplayOptions
